import apiUrl from '../../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import utils from '../../../../utils/validateScanner.js';
import user_tracker from '../../../../usertracker'
import { showMandatoryWeighingSnackbar, handleMandatoryWeighingHardBlock } from '../../../../utils/mandatoryWeighingResponse.js';

export default {
	name: 'rto-dto-print-label',
	mixins: [utils],
	components: {
		VueElementLoading
	},
	data: function() {
		return {
			barcode:'',
			shipmentData:[],
			userData:[],
			isLoading: false,
			showTable:false,
			prnData: '',
			userHubId: 0,
			createdby:'',
			restrictiontype:'stickerprinting',
			shippingIdForColor: '',
		}
	},
	created: function() {},
	model: {
	},
	computed: {
	},
	filters: {
	},
	mounted() {
	this.$refs.barcode.focus();
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
	this.userData = userdetail;
    this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0];
	this.createdby = userdetail[0].email;
	this.hubid = userdetail[0].HubId[0];
    this.hubForManualRestriction();

//HUb-6220 | PXB-6031: Single Page flow for Printing & Linking Sticker- Hubops
		var permissionEncrypt = window.localStorage.getItem('permissiondata')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var permissiondata = JSON.parse(plaintext);
	 
		for(let i = 0; i < permissiondata.length; i++) {
		  let data = permissiondata[i];
		  let menuItem = data.name.replace(/\s+/g, '').toLowerCase();
		  if (menuItem === "printsticker"){
			 this.isDisabled = true; // Disable current page
		  }
	  }
	  
	},
	methods: {
		resetData(){
			this.barcode='',
			this.shipmentData='',
			this.showTable=false,
			this.isLoading=false,
			this.prnData = '',
			this.$refs.barcode.focus(),
			this.$validator.reset();
      this.errors.clear();
	  this.showHideCodeIconInput();
		},

		showdetails(){
			this.$validator.validateAll().then((result) => {
        if (result) {
					this.shipmentData=[]; this.prnData='';
					this.showTable=false; this.isLoading=true;
					this.input = {
								"FlyerShippingId": this.barcode,
								"CurrentHubID": this.userHubId
					}
					axios({
							method: 'GET',
							url: apiUrl.api_url_hubops + 'getShipmentDetailsForRtoDtoSlip' + "?FlyerShippingId=" + this.barcode + "&CurrentHubID=" + this.userHubId + "&PrintedFrom=" + "HubOps"+ "&source=" + "Web"+ "&PrintedBy=" + this.createdby,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',

							}
						})
						.then(result => {
							if (handleMandatoryWeighingHardBlock(this, result.data, 'getShipmentDetailsForRtoDtoSlip')) {
								this.isLoading = false;
								return;
							}
							if (result.data.ResultCode == 100) {
								showMandatoryWeighingSnackbar(this, result.data);
								this.shipmentData=result.data.ResponseData;
								if(Object.keys(result.data.lossCategorization).length !=0){
									this.shippingIdForColor=this.barcode;
									this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
								}
								this.shipmentData.rtogctype = (this.shipmentData.rtogctype) ? ' (' + this.shipmentData.rtogctype + ')' : '';

								if(this.shipmentData.shipmenttype && this.shipmentData.shipmenttype.toLowerCase()=='dto'){
									// this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
									//  '1911A1402740338' + this.shipmentData.shipmenttype + '\n' +
									//  '1X1100002420000L400001\n' +
									//  '1911A1202470162' + this.shipmentData.rtogcregion + this.shipmentData.rtogctype + '\n' +
									//  '1911A1202470253' + this.shipmentData.destination + '\n' +
									//  '1911A1202470308' + this.shipmentData.routenumber + '\n' +
									//  '1911A1202470347' + this.shipmentData.routecode + '\n' +
									//  '1911A0602740082Delivering Happiness\n' +
									//  '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002410289L001028\n' + '1X1100002420344L001027\n' +
									//  '1X1100001670000L400001\n' + '1X1100001290000L400001\n' + '1X1100000810000L400001\n' + '1X1100000420000L400001\n' + '1911A0801480007Vendor\n' +
									//  '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' + '1911A0800470007Hub :-\n' +
									//  '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190298Last WH Handover Date\n' +
									//  '1911A1202070303' + this.shipmentData.lastwhhandoverdateformated + '\n' +
									//  '1X1100001670289L001076\n' +
									//  '1911A0600660253' + this.shipmentData.clientname1 + '\n' +
									//  '1911A0600570253' + this.shipmentData.clientname2 + '\n' +
									//  '1911A0600480253' + this.shipmentData.clientname3 + '\n' +
									//  '1911A0601140074' + this.shipmentData.vendoraddress1 + '\n' +
									//  '1911A0601050074' + this.shipmentData.vendoraddress2 + '\n' +
									//  '1911A0600960074' + this.shipmentData.vendoraddress3 + '\n' +
									//  '1911A0600870074' + this.shipmentData.vendoraddress4 + '\n' +
									//  '1911A0601530073' + this.shipmentData.vendorname1 + '\n' +
									//  '1911A0601440073' + this.shipmentData.vendorname2 + '\n' +
									//  '1911A0601350073' + this.shipmentData.vendorname3 + '\n' +
									//  '1911A0600660080' + this.shipmentData.destinationhub1 + '\n' +
									//  '1911A0600570080' + this.shipmentData.destinationhub2 + '\n' +
									//  '1911A0600480080' + this.shipmentData.destinationhub3 + '\n' +
									//  '1911A0800180007Delivery Pincode :-\n' + '1X1100000010102L001041\n' +
									//  '1911A0802500007Remarks :- ' + this.shipmentData.remarks + '\n' +
									//  '1X1100000430069L001125\n' + '1X1100000430193L001038\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
									//  '1911A1202740183' + this.shipmentData.dummyRouteCodeData + '\n' +
									//  '1e6205201840010B' + this.shipmentData.shippingid + '\n' +
									//  '1911A0801700066' + this.shipmentData.shippingid + '\n' +
									//  '1X1100001680228L001075\n' + '1911A0602190240Flier Code\n' +
									//  '1911A1201840242' + this.shipmentData.truncfliercode + '\n' +
									//  '1a3101800190210' + this.shipmentData.poid + '\n' +
									//  '1911A0600070245' + this.shipmentData.poid + '\n' +
									//  '1911A0600200107' + this.shipmentData.deliverypincode + '\n' +
									//  '1X1100000010137L001042\n' + '1911A0600200145POID/ Order ID\n' +
									//  '1911A0801420308' + this.shipmentData.ewaybill + '\n' +
									//  '1X1100001300300L001038\n' + '1911A0801420246E-way Bill\n' + '1X1100001300241L001038\n' +
									//  'Q0001\n' +
									//  'E\n';
									this.prnData = `^XA
										^SZ2^JMA
										^MCY^PMN
										^PW812
      									~SD12^MD0^MTD
										~JSN
										^JZY
										^LH0,0^LRN
										^XZ
										^XA
										^FO3,73
										^GB803,0,3^FS
										^FO3,134
										^GB803,0,3^FS
										^FO3,240
										^GB803,0,3^FS
										^FO3,328
										^GB803,0,3^FS
										^FO3,423
										^GB803,0,3^FS
										^FO3,516
										^GB803,0,3^FS
										^FO332,75
										^GB0,61,3^FS
										^FO482,77
										^GB0,250,3^FS
										^FO560,77
										^GB0,250,3^FS
										^FO710,76
										^GB0,61,3^FS
										^FO149,241
										^GB0,350,3^FS
										^FO393,425
										^GB0,91,3^FS
										^FO504,426
										^GB0,91,3^FS
										^FO301,520
										^GB0,65,3^FS
										^FT33,43
										^CI0`;
									let DTOPlacement = `FT730,48`;
									if(result.data.isReverseWeightCapturedCheck === true){
										this.prnData = this.prnData + `^MMT
										^PW609
										^LL0420
										^LS0
										^FO719,1^GFA,01152,01152,00012,:Z64:eJzt0jFuAjEQBVAbFy59BN8E52Bo1wiJHIOjxFGadHsENkqREksUGGF2Mp6xTYrUqeICPdAw69n5QvzB0XOnBPDNBiA2O4DcDHgqVXGoXcBLqJ0MFrv6Zxv5ezkj1qqltukfQtBPIz1ZUqkjq2XE/jZwe7wDmJl9AFg0PcBME95Nke3zjLPIRN7FbidTmZE7i9y9FsOIcw3Fg3AjLOyNOL7gjGv26Yh2xVlcZl2d5C1K8JZ9v/ru5e7HbmzbnN0K7cnJ7i1Zos37w3rujiqaVh+xqlqdRZ4C91RxNZhu6bqTsAd2RptjoDtv0PoUeC6VhbqwB9yJvAWafa1A+jvbKdj64SlXB+X4vdkdJHvY8nt+w7VMr2RT/PVJu9Af6POF9xXRVw6HokoODe+a914zUHNS3kDNicNSVfNDWUpsszwyVu7WsidLJrklNnpkVdgfGdbQyqlI/J/fzzcXE+tw:7AD7\n`;
										DTOPlacement = `FT690,51`;
									}
									this.prnData = this.prnData + `^A0N,38,30^FDXPRESSBEES^FS
										^FT115,65
										^A0N,17,23^FDDelivering Happiness^FS
										^FT480,36
										^A0N,20,23^FDPrinted By^FS
										^FT480,61
										^A0N,20,23^FD${this.createdby.split('@')[0]}^FS
										^FT401,51
										^A0N,39,26^FD${this.shipmentData.dummyRouteCodeData}^FS
										^${DTOPlacement}
										^A0N,39,26^FD${this.shipmentData.shipmenttype}^FS
										^FT31,114
										^A0N,42,30^FDRemarks :-^FS
										^FT176,116
										^A0N,42,30^FD${this.shipmentData.remarks}^FS
										^FT341,114
										^A0N,42,30^FD${this.shipmentData.rtogcregion + this.shipmentData.rtogctype}^FS
										^FT510,114
										^A0N,42,30^FD${this.shipmentData.destination}^FS
										^FT587,114
										^A0N,42,30^FD${this.shipmentData.routenumber}^FS
										^FT730,114
										^A0N,42,30^FD${this.shipmentData.routecode}^FS
										^FT489,170
										^A0N,31,16^FDFlier Code^FS
										^FT490,211
										^A0N,23,28^FD${this.shipmentData.truncfliercode}^FS
										^FT571,170
										^A0N,28,19^FDLast WH Handover Date^FS
										^FT570,211
										^A0N,23,28^FD${this.shipmentData.lastwhhandoverdateformated}^FS
										^FO18,148
										^BY2^BCN,50,N,N^FD>:${this.shipmentData.shippingid}^FS
										^FT140,225
										^A0N,25,27^FD${this.shipmentData.shippingid}^FS
										^FT489,295
										^A0N,34,18^FDEway Bill^FS
										^FT589,296
										^A0N,34,28^FD${this.shipmentData.ewaybill}^FS
										^FT22,277
										^A0N,34,23^FDVendor^FS
										^FT22,311
										^A0N,34,23^FDName :-^FS
										^FT157,271
										^A0N,25,20^FD${this.shipmentData.vendorname1}^FS
										^FT157,297
										^A0N,25,20^FD${this.shipmentData.vendorname2}^FS
										^FT157,323
										^A0N,25,20^FD${this.shipmentData.vendorname3}^FS
										^FT23,370
										^A0N,34,23^FDVendor^FS
										^FT23,405
										^A0N,34,23^FDAddress :-^FS
										^FT158,355
										^A0N,17,25^FD${this.shipmentData.vendoraddress1}^FS
										^FT158,375
										^A0N,17,25^FD${this.shipmentData.vendoraddress2}^FS
										^FT158,395
										^A0N,17,25^FD${this.shipmentData.vendoraddress3}^FS
										^FT158,415
										^A0N,17,25^FD${this.shipmentData.vendoraddress4}^FS
										^FT23,465
										^A0N,34,23^FDDestination^FS
										^FT23,500
										^A0N,34,23^FDHub :-^FS
										^FT160,455
										^A0N,28,25^FD${this.shipmentData.destinationhub1}^FS
										^FT160,480
										^A0N,28,25^FD${this.shipmentData.destinationhub2}^FS
										^FT160,505
										^A0N,28,25^FD${this.shipmentData.destinationhub3}^FS
										^FT408,465
										^A0N,34,22^FDClient^FS
										^FT408,498
										^A0N,34,22^FDName :-^FS
										^FT513,450
										^A0N,25,25^FD${this.shipmentData.clientname1}^FS
										^FT513,476
										^A0N,25,25^FD${this.shipmentData.clientname2}^FS
										^FT513,500
										^A0N,25,25^FD${this.shipmentData.clientname3}^FS
										^FT15,545
										^A0N,25,25^FDDelivery^FS
										^FT15,570
										^A0N,25,25^FDPincode :-^FS
										^FT170,554
										^A0N,28,38^FD${this.shipmentData.deliverypincode}^FS
										^FT320,548
										^A0N,23,16^FDPO ID /^FS
										^FT320,570
										^A0N,23,16^FDOrderId :-^FS
										^FO400,530
										^BCN,27,N,N^FD>:${this.shipmentData.poid}^FS
										^FT472,580
										^A0N,23,23^FD${this.shipmentData.poid}^FS
										^PQ1,0,1,Y
										^XZ`;
								 }else{
									let rtopdd = (this.shipmentData.rtopdd == undefined || this.shipmentData.rtopdd == null || this.shipmentData.rtopdd == '') ? '' : this.shipmentData.rtopdd.toString().substring(0, 10);
									//  this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
									//  '1911A1402740337' + this.shipmentData.shipmenttype + '\n' +
									//  '1X1100002420000L400001\n' +
									//  '1911A1202470162' + this.shipmentData.rtogcregion + this.shipmentData.rtogctype + '\n' +
									//  '1911A1202470253' + this.shipmentData.destination + '\n' +
									//  '1911A1202470308' + this.shipmentData.routenumber + '\n' +
									//  '1911A1202470353' + this.shipmentData.routecode + '\n' +
									//  '1911A0602740082Delivering Happiness\n' +
									//  '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002420289L001027\n' + '1X1100002420344L001027\n' + '1X1100001670000L400001\n' + '1X1100001290000L400001\n' +
									//  '1X1100000810000L400001\n' + '1X1100000420000L400001\n' +
									//  '1e6205201840010B' + this.shipmentData.shippingid + '\n' +
									//  '1911A1001670042' + this.shipmentData.shippingid + '\n' +
									//  '1911A0801480007Vendor\n' + '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' +
									//  '1911A0800470007Hub :-\n' + '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190290Last WH Handover Date\n' +
									//  '1911A1201840289' + rtopdd + '\n' +
									//  '1X1100001680265L001075\n' +
									//  '1911A0600660253' + this.shipmentData.clientname1 + '\n' +
									//  '1911A0600570253' + this.shipmentData.clientname2 + '\n' +
									//  '1911A0600480253' + this.shipmentData.clientname3 + '\n' +
									//  '1911A0601140080' + this.shipmentData.vendoraddress1 + '\n' +
									//  '1911A0601050080' + this.shipmentData.vendoraddress2 + '\n' +
									//  '1911A0600960080' + this.shipmentData.vendoraddress3 + '\n' +
									//  '1911A0600870080' + this.shipmentData.vendoraddress4 + '\n' +
									//  '1911A0601480078' + this.shipmentData.vendorname1 + '\n' +
									//  '1911A0601390078' + this.shipmentData.vendorname2 + '\n' +
									//  '1911A0600660080' + this.shipmentData.destinationhub1 + '\n' +
									//  '1911A0600570080' + this.shipmentData.destinationhub2 + '\n' +
									//  '1911A0600480080' + this.shipmentData.destinationhub3 + '\n' +
									//  '1911A0800170007Delivery Pincode :-\n' + '1X1100000010129L001041\n' +
									//  '1911A0800170133' + this.shipmentData.deliverypincode + '\n' +
									//  '1X1100000420194L001039\n' + '1X1100000010194L001042\n' + '1911A0800160197E-way Bill\n' + '1X1100000010274L001042\n' +
									//  '1911A0800170285' + this.shipmentData.ewaybill + '\n' +
									//  '1911A0802500007Delivery Type :- ' + this.shipmentData.deliverytype + '\n' +
									//  '1X1100000430069L001125\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
									//  '1911A1202740183' + this.shipmentData.dummyRouteCodeData + '\n' + 'Q0001\n' + 'E\n';
									this.prnData = `^XA
										^SZ2^JMA
										^MCY^PMN
										^PW812
      									~SD12^MD0^MTD
										~JSN
										~SD25^MD0
										^JZY
										^LH0,0^LRN
										^XZ
										^XA
										^FO3,73
										^GB803,0,3^FS
										^FO2,142
										^GB805,0,3^FS
										^FO3,248
										^GB803,0,3^FS
										^FO3,336
										^GB803,0,3^FS
										^FO8,432
										^GB803,0,3^FS
										^FO8,524
										^GB803,0,3^FS
										^FO309,75
										^GB0,66,3^FS
										^FO466,75
										^GB0,66,3^FS
										^FO560,75
										^GB0,66,3^FS
										^FO710,75
										^GB0,66,3^FS
										^FO560,146
										^GB0,101,3^FS
										^FO149,249
										^GB0,91,3^FS
										^FO149,340
										^GB0,91,3^FS
										^FO148,434
										^GB0,91,3^FS
										^FO393,435
										^GB0,91,3^FS
										^FO504,434
										^GB0,91,3^FS
										^FO215,524
										^GB0,60,3^FS
										^FO361,524
										^GB0,60,3^FS
										^FO504,524
										^GB0,60,3^FS
										^FT33,43
										^CI0
										^A0N,38,30^FDXPRESSBEES^FS
										^FT115,65
										^A0N,17,23^FDDelivering Happiness^FS
										^FT480,36
										^A0N,20,23^FDPrinted By^FS
										^FT480,61
										^A0N,20,23^FD${this.createdby.split('@')[0]}^FS
										^FT382,63
										^A0N,45,30^FD${this.shipmentData.dummyRouteCodeData}^FS
										^FT712,54
										^A0N,45,30^FD${this.shipmentData.shipmenttype}^FS
										^FT21,118
										^A0N,42,30^FDDelivery Type : ${this.shipmentData.deliverytype}^FS
										^FT318,118
										^A0N,42,30^FD${this.shipmentData.rtogcregion + this.shipmentData.rtogctype}^FS
										^FT487,118
										^A0N,42,30^FD${this.shipmentData.destination}^FS
										^FT592,118
										^A0N,42,30^FD${this.shipmentData.routenumber}^FS
										^FT730,118
										^A0N,42,30^FD${this.shipmentData.routecode}^FS
										^FO50,149
										^BY2^BCN,53,N,N^FD>:${this.shipmentData.shippingid}^FS
										^FT50,229
										^A0N,25,27^FD${this.shipmentData.shippingid}^FS
										^FT571,178
										^A0N,28,20^FDLast WH Handover Date^FS
										^FT571,224
										^A0N,30,30^FD${rtopdd}^FS
										^FT20,285
										^A0N,34,23^FDVendor^FS
										^FT20,320
										^A0N,34,23^FDName :-^FS
										^FT160,280
										^A0N,20,20^FD${this.shipmentData.vendorname1}^FS
										^FT160,317
										^A0N,20,20^FD${this.shipmentData.vendorname2}^FS
										^FT20,378
										^A0N,34,23^FDVendor^FS
										^FT20,413
										^A0N,34,23^FDAddress :-^FS
										^FT158,356
										^A0N,17,25^FD${this.shipmentData.vendoraddress1}^FS
										^FT158,377
										^A0N,17,25^FD${this.shipmentData.vendoraddress2}^FS
										^FT158,398
										^A0N,17,25^FD${this.shipmentData.vendoraddress3}^FS
										^FT158,419
										^A0N,17,25^FD${this.shipmentData.vendoraddress4}^FS
										^FT20,473
										^A0N,34,23^FDDestination^FS
										^FT20,508
										^A0N,34,23^FDHub :-^FS
										^FT158,461
										^A0N,28,25^FD${this.shipmentData.destinationhub1}^FS
										^FT158,487
										^A0N,28,25^FD${this.shipmentData.destinationhub2}^FS
										^FT158,514
										^A0N,28,25^FD${this.shipmentData.destinationhub3}^FS
										^FT410,473
										^A0N,34,23^FDClient^FS
										^FT410,503
										^A0N,34,23^FDName :-^FS
										^FT517,461
										^A0N,25,25^FD${this.shipmentData.clientname1}^FS
										^FT517,491
										^A0N,25,25^FD${this.shipmentData.clientname2}^FS
										^FT517,521
										^A0N,25,25^FD${this.shipmentData.clientname3}^FS
										^FT20,566
										^A0N,34,23^FDDelivery Pincode :-^FS
										^FT228,564
										^A0N,28,38^FD${this.shipmentData.deliverypincode}^FS
										^FT380,564
										^A0N,28,19^FDE-WAY Bill :-^FS
										^FT549,562
										^A0N,28,38^FD${this.shipmentData.ewaybill}^FS
										^PQ1,0,1,Y
										^XZ`;
								 }

								   this.showTable= result.data.showClientDetailsForRTO_DTO ? false : true ;
console.log(this.prnData);
                            		user_tracker.checkUserIP(this.userData[0], "RTODTOLabel", this.$route.path , this.input);
								 if(this.prnData){ this.printerSticker(); }

							} else if (result.data.ResultCode!=100) {
								this.showTable=false;
								this.$alertify.error(result.data.ReturnMessage)
							}
							this.isLoading=false;
						}, error => {
							this.isLoading=false;
							console.error(error)
						})
					}
				});
		},

		printerSticker() {

		 let flierRegex = new RegExp("^RVP");
		 console.log(this.prnData);
		 this.loginput = {
			CurrentHubID:			this.userHubId,
			FlyerCode: 				flierRegex.test(this.barcode.toUpperCase()) ? this.barcode : this.shipmentData.fliercode ? this.shipmentData.fliercode : '',
			FlyerShippingId: 	this.shipmentData.shippingid ? this.shipmentData.shippingid:this.barcode,
			PrintedBy: 				this.createdby,
			PrintedDate: 			moment().format('YYYY-MM-DD HH:mm:ss'),
			Status: 					'printFailed'
		 }
 		 this.input = {
 			 prnData: this.prnData,
 			 bagNumber: moment().format('DD-MM-YYYY')
 		 }
 		 axios({
			 method: "POST",
			 url: "http://localhost:4500/printer/printbagsticker",
			 data: this.input,
		 })
		 .then(result => {
				if (result.data.ResultCode == 100) {
					this.loginput.Status = 'printDone';
					this.$alertify.success('Print Generated Successfully');
					this.addStickerLog(this.loginput);
				} else {
					this.$alertify.error(result.data.ReturnMessage);
					this.addStickerLog(this.loginput);
				}
				this.isLoading=false;
		 }, error => {
			var code = error.response == undefined ? code = 0 : error.response.status;
			if (code == 500) {
				this.$alertify.error("Printer API error");
			} else if (error) {
				this.$alertify.error("Printer not connected")
			}
			this.isLoading = false;
			this.addStickerLog(this.loginput);
		 })
 	 },

	 addStickerLog(input) {
		input.PrintedFrom = "HubOps";
		input.source = 'Web';
		 axios({
			 method: "POST",
			 url: apiUrl.api_url_hubops + 'addRtoDtoStickerLogs',
			 data: input,
			 headers: {
				 'authorization': 'authkey xB84JJ89Hd25'
			 }
		 })
		 .then(result => {
			 if (result.data.ResultCode == 100) {
				 this.$alertify.success('Log Created Successfully');
				 this.barcode = "";
				 this.$refs.barcode.focus()
				 this.$validator.reset();
				 this.errors.clear();

				 if (this.shipmentData.shipmenttype.toLowerCase()=='dto' && input.Status=='printDone') {
					 this.$router.push("/DTOstickering?currentTab="+"Second");
					 window.location.reload();
				 }
			 }else{
				 this.$alertify.error(result.data.ReturnMessage);
			 }
		 }, error => {
			 this.$alertify.error(error.message);
		 })
	 },

	 checkflyer(e, restrict) {
		let id = e.target.id;
	
		// Handle the key event
		if ((e.which == 13) || (this[id].length > 5)) {
			this.reportValues(id, restrict);
		} else {
			this.inputStop = performance.now();
			if (!this.inputStart) {
				this.inputStart = this.inputStop;
			}
		}
	},
	
	reportValues(id, restrict) {
		// Update the metrics if inputStart exists
		if (this.inputStart) {
			// Check if input was too slow for manual entry
			if (((this.inputStop - this.inputStart) / this[id].length) > 50) {
				this.manualInput = true;
				this.inputStart = null;
				this.inputStop = null;
	
				if (restrict) {
					this[id] = '';
					return this.$alert('Scan the barcode, manual entry not allowed');
				}
			} else {
				this.manualInput = false;
			}
			// Reset timers
			this.inputStart = null;
			this.inputStop = null;
		}
	},
	
	restrictFlyer(id) {
		id = id.toUpperCase();
		return (id.startsWith('RVP') || id.startsWith('RVX'));
	}
}
}



// WEBPACK FOOTER //
// ./src/views/components/DTOstickering/RTODTOLabel/RTODTOLabel.js